/* eslint-disable */
/**
 * These hooks re-implement the now removed useBlocker and usePrompt hooks in 'react-router-dom'.
 * Thanks for the idea @piecyk https://github.com/remix-run/react-router/issues/8139#issuecomment-953816315
 * Source: https://github.com/remix-run/react-router/commit/256cad70d3fd4500b1abcfea66f3ee622fb90874#diff-b60f1a2d4276b2a605c05e19816634111de2e8a4186fe9dd7de8e344b65ed4d3L344-L381
 */
import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';
import type { History, Blocker, Transition } from 'history';
/**
 * Blocks all navigation attempts. This is useful for preventing the page from
 * changing until some condition is met, like saving form data.
 *
 * @param  blocker
 * @param  when
 * @see https://reactrouter.com/api/useBlocker
 */
export function useBlocker(blocker: Blocker, when = true) {
  const { navigator } = useContext(NavigationContext);
  const navi = navigator as History;

  useEffect(() => {
    if (!when) return;

    const unblock = navi?.block((tx: Transition) => {
      const locationState = tx?.location?.state as { forcePush: boolean };
      if (locationState?.forcePush) {
        unblock?.();
        tx.retry?.();
      } else {
        const autoUnblockingTx = {
          ...tx,
          retry() {
            unblock?.();
            tx.retry?.();
          },
        };

        blocker?.(autoUnblockingTx);
      }
    });

    return unblock;
  }, [navigator, blocker, when]);
}
